import React, { useEffect } from 'react';
import { useChannelStore } from '@/stores/channelStore';
import { setFocus } from '@noriginmedia/norigin-spatial-navigation';

export const Home: React.FC = () => {
  const channelId = useChannelStore((state) => state.channelId);
  const channelType = useChannelStore((state) => state.channelType);
  // 不再订阅整个 channelList，避免频道数据更新时触发不必要的重渲染
  // effect 只依赖 channelId 和 channelType，这两个值变化时才需要重新设置焦点
  useEffect(() => {
    if (channelId) {
      setFocus(`nav-channel-${channelId}-${channelType}`);
    }
  }, [channelId, channelType]);
  return null;
};
